var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbstractImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 792",
    style: {
      enableBackground: "new 0 0 612 792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:1.44;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.72;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.6,154.8c-1.3,16.9-4.2,33.7-8.6,50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.9,216.8c0.3-3.1-3.2-6.6-6.3-6.3c-3.1-0.3-6.6,3.2-6.3,6.3c-0.3,3.1,3.2,6.6,6.3,6.3 C281.7,223.5,285.2,219.9,284.9,216.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235,228.9c-3,0.3-6.3-3.1-6-6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.1,222.8c0.3,3-3.1,6.3-6,6H235"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.1,204.8c-4.4-16.3-7.3-33.2-8.6-50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.9,84.7c4,21.5,5.4,43.7,4,65.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.8,216.8c0.3-3.1-3.2-6.6-6.3-6.3c-3.1-0.3-6.6,3.2-6.3,6.3c-0.3,3.1,3.2,6.6,6.3,6.3 C248.6,223.5,252.1,219.9,251.8,216.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.1,204.8v18"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229,222.8v-18"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.1,150.3c-1.3-22,0-44.3,4.1-65.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.3,84.7c10.9,7.9,29,7.8,39.9-0.2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.9,24.4c-10.9-7.9-29-7.8-39.9,0.2c11.6-7.2,28.2-7.3,38.8-0.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281,84.5c-10.5,7.2-27.1,7.3-37.7,0.1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.6,35.4l0.9,0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.3,36l2,0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.5,73.9l-1.4,0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.4,66l2,0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.8,33.7l1.7,1.7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.7,65.4l1.2,0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.8,73.3l-1.1,0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157,46l-2.7-2.2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.5,63c1.2,0.4,2.4,1.3,3.2,2.4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.1,75.5l-1.7-1.6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.6,43.2c-1,1.4-2.6,2.5-4.3,2.7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.2,43.2l-1.6,0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.4,66c1-1.5,2.8-2.6,4.6-2.8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.3,36c0.8-1.2,2.1-2.1,3.5-2.5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.7,73.3l-2.7,2.2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.3,43.8l-1.7,0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.7,150.3V24.7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.4,33.7v41.6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.2,93.4l9-9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.9,129.1c-0.2-2.3,2.3-4.8,4.6-4.6c2.3-0.2,4.8,2.3,4.6,4.6c0.2,2.3-2.3,4.8-4.6,4.6 C414.3,133.9,411.7,131.3,411.9,129.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.4,129.1c-0.2-2.3,2.3-4.8,4.6-4.6c2.3-0.2,4.8,2.3,4.6,4.6c0.2,2.3-2.3,4.8-4.6,4.6 C143.7,133.9,141.2,131.3,141.4,129.1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.1,69.3c-0.3-3.1,3.2-6.6,6.3-6.3c3.1-0.3,6.6,3.2,6.3,6.3c0.3,3.1-3.2,6.6-6.3,6.3 C154.3,75.9,150.8,72.4,151.1,69.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.9,129.1c-0.2-2.3,2.3-4.8,4.6-4.6c2.3-0.2,4.8,2.3,4.6,4.6c0.2,2.3-2.3,4.8-4.6,4.6 C375.2,133.9,372.6,131.3,372.9,129.1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.6,93.1v57.1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.1,39.7c-0.3-3.1,3.2-6.6,6.3-6.3c3.1-0.3,6.6,3.2,6.3,6.3c0.3,3.1-3.2,6.6-6.3,6.3 C154.3,46.3,150.8,42.8,151.1,39.7z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.3,24.9l9,9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.6,83.3v0.8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.4,33.7l9-9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.3,129.1c-0.2-2.3,2.3-4.8,4.6-4.6c2.3-0.2,4.8,2.3,4.6,4.6c0.2,2.3-2.3,4.8-4.6,4.6 C104.7,133.9,102.1,131.3,102.3,129.1z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.4,150.3V33.9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.7,24.7h-23.3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.3,84.4l9-9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.2,93.4v56.9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.3,24.9H291.6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.6,39.7c-0.3-3.1,3.2-6.6,6.3-6.3c3.1-0.3,6.6,3.2,6.3,6.3c0.3,3.1-3.2,6.6-6.3,6.3 C302.8,46.3,299.3,42.8,299.6,39.7z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.3,84.4H97.2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.6,69.3c-0.3-3.1,3.2-6.6,6.3-6.3c3.1-0.3,6.6,3.2,6.3,6.3c0.3,3.1-3.2,6.6-6.3,6.3 C302.8,75.9,299.3,72.4,299.6,69.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.6,84.1h54"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.6,24.9v0.9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.6,93.1l-9-9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.1,559.4v-1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.3,559.4v-1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.2,559.4v-1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.2,559.4v-1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.5,193.9h-4.8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,193.9h4.8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7,56.6l12,0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.6,52.1l12,0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7,56.6l12,0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.6,52.1l12,0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7,61.2l12,0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.6,47.6l12,0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.8,243.4h1.5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.8,216.4h1.5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,243.4H58"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,216.4H58"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,435h6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,209.6h6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.5,435h6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,214.9h-6.9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,470.4h1.5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.1,419.9l-0.6-0.6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,214.9H453"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.7,265.4l0.6,0.6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.7,470.4h-6.9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.5,419.3h-4.8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,470.4H453"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.1,265.4l-0.6,0.6"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.8,440.3h-9.9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.1,265.4l0.6,0.6"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.2,266h-4.8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,253.8h1.5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,431.4h1.5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.5,209.6h6"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,465.9H59"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,375.5h9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,375.5h9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.7,214.9h-6.9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,444.8H59"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,244.2h0.9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,431.4h1.5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,253.8h1.5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.1,419.9l0.6-0.6"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.9,240.4h0.9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.3,470.4h1.5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,309.7h9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.7,244.9h-6.9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,215.6h0.9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,440.3h-6.9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.8,265.4l-0.6,0.6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,309.7h9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.5,266h-4.8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,244.9H453"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,470.4h-6.9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,219.4H59"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.7,419.9l0.6-0.6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,214.9h1.5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,250.2h6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,440.3H453"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,469.6h0.9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.7,440.3h-6.9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,240.4H59"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,215.6h0.9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,483.1h-9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.3,214.9h1.5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.9,444.8h0.9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,441.1h0.9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.8,470.4h-9.9"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.9,465.9h0.9"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,483.1h-9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.3,440.3h1.5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.2,419.3h-4.8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.8,244.9h-9.9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,244.9h1.5"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.8,419.9l-0.6-0.6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,469.6h0.9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.8,214.9h-9.9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,441.1h0.9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.5,250.2h6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,244.2h0.9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,244.9h-6.9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,440.3h1.5"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.3,244.9h1.5"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,202.1h-9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,202.1h-9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,475.6h6"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.5,475.6h6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.9,219.4h0.9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,441.8H58"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.8,441.8h1.5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,468.9H58"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.8,468.9h1.5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.7,56.6l0,2.3l0,2.3"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.7,52.1l0,2.3l0,2.3"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.6,47.6l0,2.3l0,2.3"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.7,504.9l-3.3-19.5"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,345.6h-0.9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,339.6h-0.9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,180.3h0.9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.2,504.9l3.3-19.5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.2,339.6l3.3-19.5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.4,365.2l3.3-19.5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,339.6h0.9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.5,365.2l-3.3-19.5"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.5,199.8l-3.3-19.5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,180.3h-0.9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,504.9h-0.9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.7,339.6l-3.3-19.5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,504.9h0.9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,345.6h0.9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.4,199.8l3.3-19.5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7,63.7l-0.1-18.6l-4.5-1.2"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.2,64.9l3.3,0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.4,43.9c0.6-0.1,1.3,0.6,1.2,1.2"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7,63.7c0.1,0.6-0.6,1.3-1.2,1.2"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.5,491.3h-4.8"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,491.3h4.8"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.2,194h-4.8"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.7,194h4.8"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,45.1l-1.1,0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.6,63.7l1.1,0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.4,45l0-1.1"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.5,64.9l0-1.1l-3.1-0.1"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.3,45.1l3,0l0.2,17.7"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440,183.3v12"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.5,183.3v12"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,489.9v12"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.9,489.9v12"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.9,195.3v-12"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,195.3v-12"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.5,501.9v-12"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440,501.9v-12"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,501.9h-2.3h-2.3"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.9,183.3h2.3h2.3"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.5,501.9h2.3h2.3"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440,183.3h-2.3h-2.3"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172,81.9l0-9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.2,72.4l0,9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.2,84.5l-9,0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,253.8v9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.8,27.8c-0.2-1.5,1.5-3.2,3-3"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,253.8v9"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.8,24.8l9,0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,422.4v9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.8,36.8l0-9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292,27.4l0,9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,24.4l9,0"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.2,81.5c0.2,1.5-1.5,3.2-3,3"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,422.4v9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,84.9l-9,0c-1.5,0.2-3.2-1.5-3-3"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289,24.4c1.5-0.2,3.2,1.5,3,3"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.9,195.3h-9.6l-1.2,4.5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432.9,195.3c-0.6-0.1-1.3,0.6-1.2,1.2"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.7,199.8v-3.3"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.7,196.5c0.1-0.6-0.6-1.3-1.2-1.2l1.2,4.5"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432.9,195.3h9.6"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.1,488.7v-3.3"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.3,489.9c-0.6,0.1-1.3-0.6-1.2-1.2"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.1,485.4v3.3"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.1,488.7c0.1,0.6-0.6,1.3-1.2,1.2"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.3,489.9h9.6"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.7,488.7c-0.1,0.6,0.6,1.3,1.2,1.2l-1.2-4.5"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M442.5,489.9c0.6,0.1,1.3-0.6,1.2-1.2"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.7,485.4v3.3l-10.8,1.2"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.9,195.3c0.6-0.1,1.3,0.6,1.2,1.2"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.1,199.8v-3.3"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.1,196.5c-0.1-0.6,0.6-1.3,1.2-1.2"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.9,77c0.2-2.1-2.1-4.4-4.2-4.2c-2.1-0.2-4.4,2.1-4.2,4.2c-0.2,2.1,2.1,4.4,4.2,4.2 C286.8,81.4,289.1,79,288.9,77z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,84.9l96.2-0.4"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.2,72.4l-0.1-36.1"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.8,36.8l0.1,36.1"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.3,77.4c-0.2-2.1,2.1-4.4,4.2-4.2c2.1-0.2,4.4,2.1,4.2,4.2c0.2,2.1-2.1,4.4-4.2,4.2 C177.4,81.8,175.1,79.4,175.3,77.4z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,24.4l-96.2,0.4"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.3,31.9c-0.2-2.1,2.1-4.4,4.2-4.2c2.1-0.2,4.4,2.1,4.2,4.2c0.2,2.1-2.1,4.4-4.2,4.2 C282.5,36.3,280.1,34,280.3,31.9z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.5,32.3c0.2-2.1-2.1-4.4-4.2-4.2c-2.1-0.2-4.4,2.1-4.2,4.2c-0.2,2.1,2.1,4.4,4.2,4.2 C181.4,36.7,183.8,34.4,183.5,32.3z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.6,196.5h1.1H442.6z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.9,196.4v-1.1"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.3,195.3v1.1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.9,489.9v-1.1"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.2,196.5h-1.1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.8,488.7h-1.1"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90,488.7h1.1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.9,489.9v-1.1"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.9,196.4v-1.1V196.4z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.1,488.7h1.1l0.1,1.2"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.7,488.7h-1.1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.7,196.5h1.1"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.5,488.8v1.1"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.8,196.5h8.7"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.4,488.7h8.7"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.9,485.6v3"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.9,485.6v3"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.3,488.5v-3"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442,196.5h-8.7l-0.5,3.1"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.5,488.7h-8.7"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.3,199.7v-3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.5,488.5v-3"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.5,199.7v-3"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.9,196.7v3"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.8,240.4v-10.5v-10.5"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,240.4v-10.5v-10.5"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.8,465.9v-10.5v-10.5"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,465.9v-10.5v-10.5"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.2,31.9c0.1-1.3-1.4-2.8-2.7-2.7c-1.3-0.1-2.8,1.4-2.7,2.7c-0.1,1.3,1.4,2.8,2.7,2.7 C285.9,34.7,287.4,33.2,287.2,31.9z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.2,77.4c0.1-1.3-1.4-2.8-2.7-2.7c-1.3-0.1-2.8,1.4-2.7,2.7c-0.1,1.3,1.4,2.8,2.7,2.7 C180.8,80.2,182.4,78.7,182.2,77.4z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282,77c-0.1-1.3,1.4-2.8,2.7-2.7c1.3-0.1,2.8,1.4,2.7,2.7c0.1,1.3-1.4,2.8-2.7,2.7 C283.4,79.8,281.9,78.3,282,77z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.6,32.3c-0.1-1.3,1.4-2.8,2.7-2.7c1.3-0.1,2.8,1.4,2.7,2.7c0.1,1.3-1.4,2.8-2.7,2.7 C178,35.1,176.5,33.6,176.6,32.3z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.6,29.8l1.5,0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.2,76.2l1.7,0"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.8,32.6l-1.7,0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.9,74.5l1.5,0"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.9,31.5l1.7,0"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.2,76.2l0,1.5"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.5,74.5l0,1.7"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.2,77.7l-1.7,0"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.2,77.7l0-1.5l1.7-1.7"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284,77.7l-1.7,0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.5,76.2l1.7,0"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284,79.5l0-1.7l1.5,1.7"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.3,34.4l-1.5,0"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287,31.1l0,1.5l-1.7,1.7"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.8,29.4l1.5,0l1.7,1.7"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,32.7l0-1.5"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.8,34.4l0-1.7"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,31.1l1.7,0"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287,32.6l-1.7,0l-1.5-3.2l1.5,1.7"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177,78.1l0-1.5l1.7-1.7"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.3,79.8l-1.5,0"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.3,74.9l0,1.7"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182,78.1l-1.7,0l0,1.7l-1.5-1.7"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.1,34.8l-1.5,0"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.8,31.5l0,1.5l-1.7,1.7"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.9,33l0-1.5"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.6,34.8l0-1.7l0-3.2l1.5,1.7l-3.2,1.5"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.8,33l-1.7,0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.3,76.6l1.7,0"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177,76.6l1.7,0l-1.7,1.5"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182,76.6l0,1.5"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.5,79.4l-1.5,0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.1,31.5l1.7,0"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.8,74.9l1.5,0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.4,54.5c0.8-7.5-7.8-16.1-15.3-15.3c-7.5-0.8-16.1,7.8-15.3,15.3c-0.8,7.5,7.8,16.1,15.3,15.3 C269.6,70.6,278.2,62.1,277.4,54.5z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175,72.9l-0.1-36.1"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.9,36.8l-9,0l-3,0"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,81.9l0,3"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.2,72.5l3,0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.1,36.4l-3,0"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.2,81.5l0-9"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.8,27.8l0,9"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.2,84.5l0-3"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.2,72.5l9,0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.8,24.8l0,3"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,72.8l0,9"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.1,36.4l0.1,36.1"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175,72.9l9,0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.2,81.5L184,81.9"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.1,36.4l-9,0l0-9"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.8,27.8l96.2-0.4"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172,72.9l3,0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,27.4l0-3"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.3,243.4v-13.5v-13.5l-1.5,13.5v13.5"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58,216.4v13.5v13.5"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.3,468.9v-13.5v-13.5l-1.5,13.5v13.5"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58,441.8v13.5v13.5"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,375.5v5.4"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,304.3v5.4"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,304.3v5.4"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,375.5v5.4"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,244.2v-14.3v-14.3"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.9,244.2v-14.3v-14.3"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.9,469.6v-14.3v-14.3"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,469.6v-14.3v-14.3"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.8,440.5v14.8v14.8"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.8,215.1v14.8v14.8"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453,440.5v14.8v14.8"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453,215.1v14.8v14.8"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.9,214.9v15v15"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,214.9v15v15"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,244.9v-15v-15"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,214.9v15v15"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.9,440.3v15v15"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,214.9v15v15"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,440.3v15v15"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,244.9v-15v-15"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,470.4v-15v-15v15V470.4z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,470.4v-15v-15v15V470.4z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,317.1v-9"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,211.9v-9"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,199.8H74"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,317.1v-9"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,320.1l3-3"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,320.1h0.9"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,365.2H74"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,368.2l3-3"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,485.4l-3-3"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,485.4h-0.9"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,377.2v-9"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,202.9l-3-3h-0.9"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,482.4v-9"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,377.2v-9"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,365.2h-0.9"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,202.9l3-3"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,485.4l3-3"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,320.1l-3-3"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,482.4v-9"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,368.2l-3-3"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,320.1h-0.9"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,211.9v-9"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,485.4h0.9"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.3,435v20.3v20.3"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.5,209.6v20.3v20.3"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.3,209.6v20.3v20.3"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.5,435v20.3v20.3"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,308.4h0.9"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,316.8h0.9"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,204.7c-0.1-0.7,0.8-1.6,1.5-1.5"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,211.6h-0.9"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,203.2h-0.9"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.2,480.6c0.1,0.7-0.8,1.6-1.5,1.5"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,475.2c-0.1-0.7,0.8-1.6,1.5-1.5H74"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,482.1H74"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,376.9h-0.9"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,211.6h-0.9"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,473.7h0.9"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,309.9c-0.1-0.7,0.8-1.6,1.5-1.5"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,316.8c-0.7,0.1-1.6-0.8-1.5-1.5"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,308.4H74"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,316.8H74"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,370c-0.1-0.7,0.8-1.6,1.5-1.5"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,376.9h-0.9"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,368.5h-0.9"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,368.5c0.7-0.1,1.6,0.8,1.5,1.5"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,211.6c-0.7,0.1-1.6-0.8-1.5-1.5"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,473.7c0.7-0.1,1.6,0.8,1.5,1.5"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,482.1c-0.7,0.1-1.6-0.8-1.5-1.5"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.2,210.1c0.1,0.7-0.8,1.6-1.5,1.5"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,376.9c-0.7,0.1-1.6-0.8-1.5-1.5"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.2,375.4c0.1,0.7-0.8,1.6-1.5,1.5"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,308.4c0.7-0.1,1.6,0.8,1.5,1.5"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.2,315.3c0.1,0.7-0.8,1.6-1.5,1.5"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,203.2h-0.9c1.6-0.1,2.5,0.8,2.4,1.5"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,368.5h-0.9"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,482.1h0.9"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.1,54.5c-0.7-7.4,7.6-15.8,15-15c7.4-0.7,15.8,7.6,15,15c0.7,7.4-7.6,15.8-15,15 C254.7,70.3,246.3,61.9,247.1,54.5z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.1,54.5c-0.2-1.5,1.5-3.2,3-3c1.5-0.2,3.2,1.5,3,3c0.2,1.5-1.5,3.2-3,3C260.6,57.7,258.9,56,259.1,54.5z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,339.6h7.5"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,339.6h-7.5"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,180.3h7.5"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,345.6h-7.5"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,504.9h7.5"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,180.3h-7.5"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.4,54.5c0.7-7-7.3-15-14.3-14.3c-7-0.7-15,7.3-14.3,14.3c-0.7,7,7.3,15,14.3,14.3 C269.1,69.5,277.1,61.5,276.4,54.5z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,504.9h-7.5"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,345.6h7.5"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.3,54.5c0.2-2.1-2.1-4.4-4.2-4.2c-2.1-0.2-4.4,2.1-4.2,4.2c-0.2,2.1,2.1,4.4,4.2,4.2 C264.2,59,266.5,56.6,266.3,54.5z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.2,315.3v-2.7v-2.7"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,204.7v2.7v2.7"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.2,204.7v2.7v2.7"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,480.6v-2.7v-2.7"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,315.3v-2.7v-2.7"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,370v2.7v2.7"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.2,370v2.7v2.7"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,304.3H340"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,262.8h1.5"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,380.9h-10.5"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,422.4h1.5"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,304.3h10.5"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,262.8h-1.5"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.2,480.6v-2.7v-2.7"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,380.9h10.5"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,422.4H340"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275.6,54.5c0.7-6.7-6.9-14.2-13.5-13.5c-6.7-0.7-14.2,6.9-13.5,13.5c-0.7,6.7,6.9,14.2,13.5,13.5 C268.7,68.7,276.3,61.2,275.6,54.5z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M449.7,473.7v4.2v4.2"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.1,420.9h1.4"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.8,382.4h9.5"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.1,211.5v-4.2v-4.2"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.7,420.9h-1.4"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.4,264.3h-1.4"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M449.7,308.4v4.2v4.2"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.1,376.8v-4.2v-4.2"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.1,308.4v4.2v4.2"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350,382.4h-9.5"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M449.7,376.8v-4.2v-4.2"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.3,302.8h-9.5"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.5,302.8h9.5"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M449.7,211.5v-4.2v-4.2"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.4,264.3h1.4"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.1,473.7v4.2v4.2"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,304.3v-1.5"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,304.3v-1.5"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,264.3v-1.5"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,237.5h9"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,237.5v26.8l-1.5,38.5"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,382.4v38.5"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,447.8h-9"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,422.4v-1.5"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,382.4v-1.5"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,420.9v26.8"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,264.3v-1.5l0,40"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,237.5v26.8"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,237.5h-9"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,382.4v38.5"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,447.8h9"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,420.9v26.8"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,382.4v-1.5"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,422.4v-1.5"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,483.1h-1.5"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,317.8h-1.5"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,211.9v96.2"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,320.1H352"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.1,199.8h17.7"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,367.4h1.5"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,320.1h-17.7"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,483.1h1.5"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,202.1h1.5"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,317.8h1.5"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,199.8h13.5"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,365.2H74"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,485.4h13.5"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,485.4h17.7"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,320.1h17.7"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,365.2h-13.5"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,377.2v96.2"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,365.2h13.5"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,367.4h-1.5"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,211.9v96.2"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,320.1h13.5"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,199.8H74"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,202.1h-1.5"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,377.2v96.2"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,199.8h-13.5"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.1,365.2h17.7"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,485.4h-17.7"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,485.4H352"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.2,482.4h-1.4"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.6,368.2h1.4"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.2,368.2h-1.4"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.6,317.1h1.4"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.6,202.9h1.4"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.2,202.9h-1.4"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.2,317.1h-1.4"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.6,482.4h1.4"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,368.2v87.2v27.1"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,229.9v87.2"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,202.9v27.1"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,368.2v87.2"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,229.9v87.2"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,202.9v27.1"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.5,455.3v27.1"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.1,184.8h6.8"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.9,500.4h6.8"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.9,335.1h6.8"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.7,350.1h-6.8"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.1,350.1h6.8"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.7,184.8h-6.8"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.9,335.1h-6.8"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.9,500.4h-6.8"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,184.8v15.4"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,184.8v-4.5"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,319.7v15.4"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,319.7h-7.5"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,339.6v-4.5"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,319.7v15.4"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,200.2h7.5"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,485v15.4"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,504.9v-4.5"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,350.1v-4.5"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,350.1v15.4"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,485v15.4"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,485h-7.5"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,485h7.5"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,365.6h-7.5"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,184.8v-4.5"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,184.8v15.4"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,319.7h7.5"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,339.6v-4.5"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,350.1v15.4"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,504.9v-4.5"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.3,200.2h-7.5"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,350.1v-4.5"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,365.6h7.5"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.7,317.1h-18.9"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.1,482.4H372"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.9,482.4h-16"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.1,317.1H372"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.9,202.9h-16"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.7,482.4h-18.9"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.8,202.9h3.7"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372,368.2h-18.9"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.8,202.9h18.9"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.9,202.9h16"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.9,368.2h-16"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.9,317.1h-16"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386,202.9h-3.7"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432,482.4h16"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.8,368.2h18.9"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372,202.9h-18.9"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.9,368.2h16"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432,317.1h16"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,473.4v9"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,368.2v9"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,368.2v-3"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,482.4V368.2"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,317.1v3"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,308.1v9"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,308.1h-3h-0.9"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,320.1v-3"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,211.9h3"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,211.9h0.9"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,199.8v3v9"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,308.1v-96.2"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,202.9v-3"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,317.1V202.9"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.1,272.1h-12"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,473.4v9"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.4,272.1h12"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43,257h13.5"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,473.4v-96.2"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,317.1V202.9"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,368.2v-3"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,377.2h-3"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,377.2h-0.9"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,365.2v3"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,473.4h3"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,482.4v3"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,473.4H74"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,485.4v-3"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,377.2h3"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,377.2h0.9"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,365.2v3v9"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,473.4v-96.2"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,473.4h-3"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.8,482.4v3"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,317.1v3"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,308.1v9"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,308.1H74"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,320.1v-3"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,211.9h-3"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,211.9h-0.9"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,199.8v3l0,9"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,308.1v-96.2"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,202.9v-3"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,308.1h3"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,482.4V368.2"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.4,257h-13.5"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,485.4v-3"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,473.4h-0.9"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.4,620.6v-62.2h-61.3v62.2"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.5,547c-0.3-3.1,3.2-6.6,6.3-6.3c3.1-0.3,6.6,3.2,6.3,6.3c0.3,3.1-3.2,6.6-6.3,6.3 C406.7,553.6,403.2,550.1,403.5,547z"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.8,553l9-9"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.8,535v9"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.5,544v-9"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.6,553l-9-9"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.6,553v145.8"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.6,701.8l-3-3"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,698.8l-3,3"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,698.8V553"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.8,544l-9,9"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,547c0.3-3.1-3.2-6.6-6.3-6.3c-3.1-0.3-6.6,3.2-6.3,6.3c-0.3,3.1,3.2,6.6,6.3,6.3 C116.8,553.6,120.3,550.1,120,547z"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.3,558.4v62.2"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98,620.6v-62.2"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.6,535v9"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98,558.4h61.3"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150,547c0.3-3.1-3.2-6.6-6.3-6.3c-3.1-0.3-6.6,3.2-6.3,6.3c-0.3,3.1,3.2,6.6,6.3,6.3 C146.8,553.6,150.3,550.1,150,547z"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.8,553v145.8"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.8,701.8l3-3"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,698.8l3,3"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,698.8V553"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.7,544l9,9"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.9,544v-9"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.4,547c-0.3-3.1,3.2-6.6,6.3-6.3c3.1-0.3,6.6,3.2,6.3,6.3c0.3,3.1-3.2,6.6-6.3,6.3 C376.6,553.6,373.1,550.1,373.4,547z"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,447.8v24.3v11"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,202.1v11v24.3"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,202.1v11v24.3"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,447.8v24.3v11"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.9,426.8h13.5"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.1,410.8h12"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,426.8H43"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,410.8h-12"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.5,544h3"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.8,544h3"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.6,544h-3"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.9,544h-3"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.6,54.5c-0.5-5.2,5.3-11,10.5-10.5c5.2-0.5,11,5.3,10.5,10.5c0.5,5.2-5.3,11-10.5,10.5 C256.9,65.5,251,59.7,251.6,54.5z"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,54.5c0.6-5.9-6.1-12.6-12-12c-5.9-0.6-12.6,6.1-12,12c-0.6,5.9,6.1,12.6,12,12 C268,67.1,274.7,60.4,274.1,54.5z"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.8,54.5c0.3-3.3-3.4-7.1-6.8-6.8c-3.3-0.3-7.1,3.4-6.8,6.8c-0.3,3.3,3.4,7.1,6.8,6.8 C265.4,61.6,269.2,57.8,268.8,54.5z"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.6,54.5c-0.2-2.2,2.3-4.7,4.5-4.5c2.2-0.2,4.7,2.3,4.5,4.5c0.2,2.2-2.3,4.7-4.5,4.5 C259.9,59.2,257.3,56.7,257.6,54.5z"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.5,544v-9"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.1,510.9h-58"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,177.3h58"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,510.9h58"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,177.3h-58"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.8,535v9"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,535v9"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.9,544v-9"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.7,419.9v34.1v36.8"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.8,490.7v-36.8v-34.1"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.1,419.9v34.1v36.8"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.7,194.6v36.9v33.9"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.8,265.4v-33.9v-36.9"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.1,194.6v36.9v33.9"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.2,419.3v34.6v37.4"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,491.3v-37.4v-34.6"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.7,419.3v34.6v37.4"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.5,491.3v-37.4v-34.6"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.2,194v37.5V266"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,266v-34.5V194"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.7,194v37.5V266"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.5,266v-34.5V194"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,544H43"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.1,535h53.5"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,544h3"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.8,544h3"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.9,516.9l-6,6"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.1,523h133.8"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.1,523l-6-6"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.1,410.8v6v100.1"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.9,544v-9"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.4,426.8v6"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.9,432.8v-6"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.4,432.8h-13.5"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.9,516.9v-84.2"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.1,535V416.9v-6"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.1,416.9h-12"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.4,432.8V535H309.1"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.9,163.8l15,15"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.6,163.8h8.3"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.1,163.8h14.3"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.1,178.8l15-15"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.1,263.1v-84.2"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.1,263.1v9"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.1,263.1h12"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.1,272.1v-9"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.4,247.9v-93.2"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.1,154.8v108.3"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,163.8l-15,15"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.3,163.8h-14.3"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.9,163.8h-8.3"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.4,178.8l-15-15"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.4,263.1v-84.2"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.4,263.1v9"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,272.1v-9h-12"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,154.8v108.3"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43,247.9v9"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43,247.9v-93.2"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,257v-9H43"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,178.8v69.1"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.9,154.8v9"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.1,163.8v-9"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,516.9l6,6"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,523H62.5"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,523l6-6"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.4,416.9v100.1"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.4,410.8v6"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43,426.8v6h13.5v-6"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,516.9v-84.2"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,416.9v-6"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,535V416.9"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.4,416.9h12"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43,432.8V535h171.4"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.1,535v9"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,535v9"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,535v9"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.6,544v-9"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.6,544h-3"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43,535v9"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,535H43"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.4,163.8v-9"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.9,544h53.5"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.9,178.8v69.1"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.6,154.8v9"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.9,535h53.5"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.9,535v9"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.9,257v-9"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.4,535v9"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.9,544h-3"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,535h-53.5"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.9,247.9h13.5"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,544h-53.5"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.1,544h53.5"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.4,247.9v9"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,276.5v12"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,291l-40-14.6"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,303.1v-12"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,288.5l40,14.6"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,384.7l-40-14.5"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,396.7v-12"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,382.2l40,14.6"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,370.1v12"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,238.9v12"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,253.5l-40-14.6"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,265.5v-12"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,250.9l40,14.6"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,462.8l-40-14.6"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,474.9v-12"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,460.3l40,14.6"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,448.3v12"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,423.8l-40-14.6"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,435.8v-12"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,409.2v12"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,201.3v12"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,215.9l-40-14.6"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,227.9v-12"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,213.4l40,14.5"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,510.9v-6V183.3v-6"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.1,504.9v6"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,504.9h58V183.3h-58"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.1,177.3v6"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,276.5v12"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,291l40-14.6"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,303.1v-12"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,288.5l-40,14.6"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,384.7l40-14.5"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,396.7v-12"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,382.2l-40,14.6"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,370.1v12"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,238.9v12"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,253.5l40-14.6"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,265.5v-12"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,250.9l-40,14.6"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,462.8l40-14.6"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,474.9v-12"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,460.3l-40,14.6"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,448.3v12"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,423.8l40-14.6"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,435.8v-12"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,421.2l-40,14.6"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,409.2v12"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,201.3v12"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,215.9l40-14.6"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,227.9v-12"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,213.4l-40,14.5"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,183.3v-6"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,504.9V183.3"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,510.9v-6"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,504.9v6"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,504.9h-58"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,183.3h58"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,504.9V183.3"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,177.3v6"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,421.2l40,14.6"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.7,559c-1.5-0.1-3.2,1.5-3,3v9"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.7,559h-9"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.8,562c0.1-1.5-1.5-3.2-3-3h-9"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.8,571.1v-9"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.7,559c1.5-0.1,3.2,1.5,3,3"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.7,559h9"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.7,562v9"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.6,562c-0.1-1.5,1.5-3.2,3-3"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.6,571.1v-9"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.6,559h9"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.6,163.8h-9"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.4,163.8h-9"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164,163.8h9"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.9,163.8h9"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.7,620.6v-49.6"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.7,559h36.1"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.8,571.1v49.6"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.9,566.5c-0.2-2.1,2.1-4.4,4.2-4.2c2.1-0.2,4.4,2.1,4.2,4.2c0.2,2.1-2.1,4.4-4.2,4.2 C104.1,571,101.7,568.6,101.9,566.5z"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.4,566.5c0.2-2.1-2.1-4.4-4.2-4.2c-2.1-0.2-4.4,2.1-4.2,4.2c-0.2,2.1,2.1,4.4,4.2,4.2 C153.3,571,155.7,568.6,155.4,566.5z"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.7,620.6v-49.6"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.7,559h-36.1"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.6,571.1v49.6"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368,566.5c-0.2-2.1,2.1-4.4,4.2-4.2c2.1-0.2,4.4,2.1,4.2,4.2c0.2,2.1-2.1,4.4-4.2,4.2 C370.1,571,367.8,568.6,368,566.5z"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.5,566.5c0.2-2.1-2.1-4.4-4.2-4.2c-2.1-0.2-4.4,2.1-4.2,4.2c-0.2,2.1,2.1,4.4,4.2,4.2 C419.4,571,421.7,568.6,421.5,566.5z"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.5,566.5c-0.1-1.3,1.4-2.8,2.7-2.7c1.3-0.1,2.8,1.4,2.7,2.7c0.1,1.3-1.4,2.8-2.7,2.7 C149.9,569.4,148.4,567.9,148.5,566.5z"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.9,566.5c0.1-1.3-1.4-2.8-2.7-2.7c-1.3-0.1-2.8,1.4-2.7,2.7c-0.1,1.3,1.4,2.8,2.7,2.7 C373.5,569.4,375.1,567.9,374.9,566.5z"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.6,566.5c-0.1-1.3,1.4-2.8,2.7-2.7c1.3-0.1,2.8,1.4,2.7,2.7c0.1,1.3-1.4,2.8-2.7,2.7 C416,569.4,414.5,567.9,414.6,566.5z"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.9,566.5c0.1-1.3-1.4-2.8-2.7-2.7c-1.3-0.1-2.8,1.4-2.7,2.7c-0.1,1.3,1.4,2.8,2.7,2.7 C107.5,569.4,109,567.9,108.9,566.5z"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.8,565.8v1.5"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.1,564.1h-1.5l-1.7,1.7"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.5,569h1.5"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.1,565.8v-1.7"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.7,567.3v-1.5"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.8,567.3v-1.5"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.4,564.1h1.5"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.6,565.8v1.5"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.9,565.8h1.7"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.7,567.3v-1.5l1.7-1.7"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.9,569h-1.5"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.6,567.3h-1.7"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.4,569v-1.7l1.5,1.7"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.4,567.3h-1.7"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.9,564.1v1.7"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.7,565.8h1.7"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.8,567.3v-1.5"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152,569h-1.5l-1.7-1.7l1.7-1.5l1.5-1.7v1.7l1.7,1.5"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152,565.8h1.7l-1.7,1.5v1.7"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.5,565.8v-1.7"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.5,569v-1.7"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.7,567.3h1.7l-1.7-1.5"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371.5,564.1v1.7l-1.7,1.5"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.7,565.8H373l-1.5-1.7"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373,567.3h1.7"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371.5,569h1.5v-1.7"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.8,565.8h-1.7l1.7,1.5"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373,565.8v-1.7"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.5,564.1v1.7"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.1,569v-1.7"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371.5,567.3v1.7"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.5,567.3v1.7"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.8,567.3h1.7"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.7,571.1h9"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.7,571.1v49.6"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.8,620.6v-49.6"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.8,571.1h9"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.8,562v9"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.8,562h-36.1"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.7,571.1v-9"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.7,571.1h3"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.7,562v-3"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.8,559v3"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.8,571.1h3"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.7,571.1h-9v-9"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,562h36.1"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,571.1h-9"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,562v9"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.6,620.6v-49.6"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.7,571.1v49.6"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.7,562v-3"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.7,571.1h-3"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,559v3"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.6,571.1h-3"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.7,649.2c-0.2-1.5,1.5-3.2,3-3c1.5-0.2,3.2,1.5,3,3c0.2,1.5-1.5,3.2-3,3 C127.2,652.4,125.5,650.7,125.7,649.2z"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.8,649.2c0.2-1.5-1.5-3.2-3-3c-1.5-0.2-3.2,1.5-3,3c-0.2,1.5,1.5,3.2,3,3 C396.2,652.4,397.9,650.7,397.8,649.2z"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.9,649.2c0.2-2.1-2.1-4.4-4.2-4.2c-2.1-0.2-4.4,2.1-4.2,4.2c-0.2,2.1,2.1,4.4,4.2,4.2 C130.8,653.6,133.1,651.3,132.9,649.2z"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.5,649.2c-0.2-2.1,2.1-4.4,4.2-4.2c2.1-0.2,4.4,2.1,4.2,4.2c0.2,2.1-2.1,4.4-4.2,4.2 C392.7,653.6,390.3,651.3,390.5,649.2z"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.3,649.2c0.5-5.2-5.3-11-10.5-10.5c-5.2-0.5-11,5.3-10.5,10.5c-0.5,5.2,5.3,11,10.5,10.5 C399.9,660.2,405.8,654.4,405.3,649.2z"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.2,649.2c-0.5-5.2,5.3-11,10.5-10.5c5.2-0.5,11,5.3,10.5,10.5c0.5,5.2-5.3,11-10.5,10.5 C123.5,660.2,117.7,654.4,118.2,649.2z"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.7,649.2c-0.6-5.9,6.1-12.6,12-12c5.9-0.6,12.6,6.1,12,12c0.6,5.9-6.1,12.6-12,12 C388.8,661.8,382.1,655.1,382.7,649.2z"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,649.2c0.6-5.9-6.1-12.6-12-12c-5.9-0.6-12.6,6.1-12,12c-0.6,5.9,6.1,12.6,12,12 C134.6,661.8,141.3,655.1,140.7,649.2z"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,649.2c0.3-3.3-3.4-7.1-6.8-6.8c-3.3-0.3-7.1,3.4-6.8,6.8c-0.3,3.3,3.4,7.1,6.8,6.8 C132,656.3,135.8,652.5,135.5,649.2z"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388,649.2c-0.3-3.3,3.4-7.1,6.8-6.8c3.3-0.3,7.1,3.4,6.8,6.8c0.3,3.3-3.4,7.1-6.8,6.8 C391.4,656.3,387.6,652.5,388,649.2z"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.2,649.2c-0.2-2.2,2.3-4.7,4.5-4.5c2.2-0.2,4.7,2.3,4.5,4.5c0.2,2.2-2.3,4.7-4.5,4.5 C126.5,653.9,124,651.4,124.2,649.2z"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M399.2,649.2c0.2-2.2-2.3-4.7-4.5-4.5c-2.2-0.2-4.7,2.3-4.5,4.5c-0.2,2.2,2.3,4.7,4.5,4.5 C397,653.9,399.5,651.4,399.2,649.2z"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.4,649.2c-0.6-6.1,6.3-12.9,12.3-12.3c6.1-0.6,12.9,6.3,12.3,12.3c0.6,6.1-6.3,12.9-12.3,12.3 C388.7,662.1,381.8,655.3,382.4,649.2z"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141,649.2c0.6-6.1-6.3-12.9-12.3-12.3c-6.1-0.6-12.9,6.3-12.3,12.3c-0.6,6.1,6.3,12.9,12.3,12.3 C134.8,662.1,141.7,655.3,141,649.2z"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.7,716.8h78.1"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.7,620.6l-6,6"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.7,716.8v-90.2"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.8,626.7v90.2"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.8,626.7l-6-6h-66.1"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.8,649.2c0.9-8.9-9.2-18.9-18-18c-8.9-0.9-18.9,9.2-18,18c-0.9,8.9,9.2,18.9,18,18 C403.6,668.1,413.7,658.1,412.8,649.2z"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,649.2c-0.9-8.9,9.2-18.9,18-18c8.9-0.9,18.9,9.2,18,18c0.9,8.9-9.2,18.9-18,18 C119.8,668.1,109.8,658.1,110.7,649.2z"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.8,716.8H89.6"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.8,620.6l6,6"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.8,716.8v-90.2"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.6,626.7v90.2"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.6,626.7l6-6h66.1"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.8,716.8v6"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.7,722.8v-6"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.6,716.8v6"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.8,722.8v-6"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164,163.8v-9"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.9,154.8v9"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.6,154.8v9"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.4,163.8v-9"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M517.2,154.8v-4.5"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.2,150.3v4.5"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.6,737.9v-15"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457.9,722.8v15"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.6,722.8v15"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.8,737.9v-15"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.8,150.3v-9"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.8,117.2h-9"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.6,150.3v-9"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.7,117.2h9"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M511.2,154.8h6"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,154.8h498.9"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.2,154.8h6"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M517.2,150.3h-6v4.5"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,154.8v-4.5h-6"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,150.3h498.9"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.6,163.8h-9"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.4,163.8h57.1"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.4,163.8h-9"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,150.3h4.5"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.2,150.3h-4.5"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.3,121.7l-4.5-4.5"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,121.7h13.5l15,15"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.5,154.8h-57.1"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.8,141.2l-4.5-4.5v13.5H19.8"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.2,121.7l4.5-4.5"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M503.7,121.7h-13.5"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.6,141.2l4.5-4.5"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.2,121.7l-15,15v13.5h28.6"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155,163.8h9"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155,163.8H97.9"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.9,163.8h9"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,154.8H155"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,163.8v-9"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155,154.8v9"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.5,163.8v-9"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.4,154.8v9"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.6,722.8h6h114.2h6"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337.6,722.8v15"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.9,737.9v-15"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,722.8h-6"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.8,722.8H71.6"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.8,722.8h-6v15"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,737.9v-15"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.6,749.9h180.3"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.6,737.9v12"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.6,737.9h180.3v12"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.9,737.9H38.5"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.9,749.9H38.5"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.9,737.9v12"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.5,737.9v12"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,30h-4.5"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M503.7,30h4.5"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,36v15l0,99.2"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,30v6"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,36v-6"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,36h4.5"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,51.1v99.2"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,51.1h4.5"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,36v15"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.2,30v6v15v99.2"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M503.7,36v-6"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.2,36h-4.5"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.2,51.1h-4.5l0,99.2"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M503.7,36v15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractImage1);
export default __webpack_public_path__ + "static/media/Abstract_Image1.313867a2e98ab51205c87c498fbaaf2d.svg";
export { ForwardRef as ReactComponent };